import React,{useState,useEffect, useRef} from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from "./style.module.scss"
import { Swiper, SwiperSlide } from 'swiper/react';
import { Iconfont } from "../../../../components/icon/iconfont";
import { IMAGE_GEEKO_LTD } from "../../../../../constants";
import RightToLeft from "../../../../components/transitions/right-to-left";
import { fetchCommentIds } from "../../../../../api";
import ProductStarScore from "../../module/product-star-score";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import withFirst from "../../hoc/withFirst";
import SwiperCore, {
	Pagination,
} from 'swiper';
import ReactPlayer from "react-player/lazy"
import { useCallback } from "react";
import { createRef } from "react";
import { withCartIcon } from "../../../listing/components/cart/cart-icon";
import useOpenWindow from '../../../../hooks/open-window';
import Badge from "../../../../components/badge";

SwiperCore.use([Pagination]);

const CartIcon = withCartIcon(props =>{
    const { onCart } = props;

    return <span className={classes.CartIcon} onClick={onCart}>
        <Iconfont>&#xe6a8;</Iconfont>
    </span>
});

const BabiesVideo = (props =>{
    const { videoId, play, item, show } = props;
    const playerRef = useRef(null);
    const [muted, setMted] = useState(true);
    const [player, setPlayer] = useState(false);
    const [showPlayer,setShowPlayer] = useState(false);
    const ref = createRef();

    useEffect(() =>{
        if(show && !player && play){
            setShowPlayer(true);
        }
    },[show]);

    useEffect(() =>{
        if(player && !show){
            setShowPlayer(false);
            setPlayer(false);
        }
    },[show]);

    useEffect(() =>{
        let ob = new IntersectionObserver(function (entries) {
            let hasIntersecting = false
            entries.forEach(function (entry) {
                if(!hasIntersecting){
                    hasIntersecting = entry.isIntersecting
                    if(!hasIntersecting){
                        if(player){
                            setShowPlayer(false);
                            setPlayer(false);
                        }
                    }
                }
            })
        }, { threshold: [1, 0.7] });

        ob.observe(ref.current)
        return () => {
            ob.disconnect()
        }
    },[player]);

    const youtubePlayEvent = () => {
        setShowPlayer(true);
    }

    const videoMuted = () =>{
        let playerItem = playerRef.current?.getInternalPlayer();

        if(playerItem.isMuted()){
            setMted(false);
        }else{
            setMted(true);
        }
    }

    return <div onClick={() =>youtubePlayEvent()} className={classes.ImageContainer} ref={ref}>
        <img src={`${IMAGE_GEEKO_LTD}/comment/medium/${item}`} alt="ProductComment"/>
        {
            showPlayer ? <React.Fragment>
                <ReactPlayer className={classes.Player}
                    ref={playerRef}
                    width='100%'
                    height='100%'
                    url={`https://www.youtube.com/watch?v=${videoId}`}
                    muted={muted}
                    playing={player}
                    onReady={() => {
                        setPlayer(true)
                    }}
                    onEnded={()=>{
                        setPlayer(false);
                        setShowPlayer(false);
                    }}
                    config={{
                        youtube: {
                            playerVars: { showinfo: 0, controls: 0, modestbranding: 1, playsinline: 1, autohide: 1, rel: 0, iv_load_policy:3 },
                            embedOptions: { showinfo: 0, controls: 0, modestbranding: 1, playsinline: 1, autohide: 1, rel: 0, iv_load_policy:3 }
                        }
                    }} 
                    
                />
                <div className={classes.BoFangMask}></div>
                <span className={`${classes.YoutubeMuted} ${!muted?classes.MutedActive:""}`} onClick={videoMuted}></span>
            </React.Fragment> : <React.Fragment>
                <img className={classes.BoFangBtn} src={`${IMAGE_GEEKO_LTD}/chicme/20220627/play.svg`} alt="Bo Fang"></img>
            </React.Fragment>
        }
    </div>
})

const BabiesItem = props =>{
    useStyles(classes);
    const { babiesItem, itemNum, play, show } = props;
    const [imageIndex,setImageIndex] = useState(1);

    const getName = (name) => {
        if (name && name.length > 2) {
            return name.replace(name.substr(1, name.length - 2), '***')
        }

        return "**";
    }

    const pagination = {
        clickable: true,
        bulletActiveClass:classes.Active
    };

    return (
        <div className={classes.BabiesItem} id={`BabiesItem${itemNum}`}>
            <div className={classes.CommentSwiper}>
                <Swiper
                    slidesPerView='auto'
                    onSlideChange={(swiper) => setImageIndex(swiper.realIndex +1)}
                    onSwiper={(swiper) => console.log()}
                    pagination={pagination}
                >
                    {
                        babiesItem?.images?.map((item,index) =>{
                            return index === 0 && babiesItem?.videoIds?.length > 0 ? (
                                <SwiperSlide key={index} className={classes.CommentSwiperItem}>
                                    <BabiesVideo item={item} videoId={babiesItem?.videoIds?.[0]} play={play} show={show} />
                                </SwiperSlide>
                            ) : (
                                <SwiperSlide key={index} className={`${classes.CommentSwiperItem} ${classes.HasAfter}`}>
                                    <img src={`${IMAGE_GEEKO_LTD}/comment/medium/${item}`} alt="ProductComment"/>
                                </SwiperSlide>
                            )
                        })
                    }
                </Swiper>

                <span className={classes.CommentImageCount}>
                    <span>{imageIndex}</span>/<span>{babiesItem?.images?.length}</span>
                </span>

                {/* <CartIcon 
                    productId={babiesItem?.productId} 
                    sensors={{
                        resourcepage_title: 'product',
                        resource_type: '28',
                        resource_content: 'InfluencerOutfit',
                        resource_position: '1'
                    }} 
                /> */}
            </div>

            <div className={classes.CommentBd}>
                <div>
                    <span className={classes.CustomerName}>{getName(babiesItem?.customerName)}</span>
                    <span><ProductStarScore starScore={babiesItem?.score} isComment={true} /></span>
                </div>
                
                <p>{babiesItem?.createTime}</p>
            </div>

            <div className={classes.CommentFd}>{babiesItem?.content}</div>
        </div>
    )
}

const BabiesLooksItem = props =>{
    useStyles(classes);
    const { ids, onClose, babiesLookShow: show, babiesPosition: position, hasRollingMessage } = props;
    const [babiesItems,setBabiesItems] = useState(null);
    const global = useSelector((state) => state.global);

    useEffect(async () =>{
        let response = await fetchCommentIds(ids);
        if(response?.code === 200){
            // let data = response?.result.map(item =>({...item,images:[...item.images,...item.images],videoId:"6fN39mnvH9k"}));
            // console.log('data', data)
            setBabiesItems(response?.result);
        }
    },[]);

    const babiesScrollIntoView = useCallback((evt) =>{
        if(position > 0){
            let babiesItemDom = document.getElementById(`BabiesItem${position}`);
            babiesItemDom?.scrollIntoView?.({
                behavior: 'smooth'
            })
        }
    },[position])

    return <div className={classes.BabiesLooksItem} style={{ height: `calc(100% - ${hasRollingMessage ? 2.453: 1.6}rem)` }}>
        <div className={classes.BabiesLooksHd}>
            <span className={classes.Font}><FormattedMessage id="influencer_outfit" defaultMessage="Influencer Outfit" /></span>
            <Iconfont className={`${classes.Icon}`} onClick={onClose}>&#xe693;</Iconfont>

            <span className={classes.ToolIcon}>
                <Badge count={global.countCart} onClick={() => {
                    window.location.href = '/cart'
                }}>
                    <Iconfont className={classes.bigger}>&#xe6a4;</Iconfont>
                </Badge>
            </span>
        </div>

        <div className={classes.BabiesLooksBd}>
            {
                babiesItems ? 
                (
                    <div className={classes.Container} ref={(element)=>babiesScrollIntoView(element)}>
                        {
                            babiesItems?.map((item,index) =><BabiesItem 
                                babiesItem={item} 
                                key={index} 
                                itemNum={index+1} 
                                play={(index+1) === position}
                                show={show}
                            />)
                        }
                    </div>
                ) : 
                (<div className={classes.Loading}><FormattedMessage id="loading" defaultMessage="Loading" /></div>)
            }
        </div>
    </div>
}

const BabiesModal = props =>{
    const { babiesLookShow } = props;

    return <RightToLeft in={babiesLookShow}>
        <BabiesLooksItem {...props} />
    </RightToLeft>
}

const BabiesElementItem = withFirst(props =>{
    const { innerRef } = props;
    
    return <img ref={innerRef} className={classes.ProductBabiesPlay} src={`${IMAGE_GEEKO_LTD}/chicme/20220627/play.svg`} alt="Play" />
});

const BabiesElement = props =>{
    const { selectedProduct } = props;

    const onLoadEvent = () =>{
        if(window.GeekoSensors){
			window.GeekoSensors.Track("ShowVideoExpose", {
                product_id:selectedProduct?.id
			})
		}
    }

    return <React.Fragment>
        <BabiesElementItem initLoad={onLoadEvent} />
    </React.Fragment>
}

const BabiesSwiper = props =>{
    useStyles(classes);
    const { babiesLooks, onShow, selectedProduct } = props;

    return (
        <Swiper
            spaceBetween={10}
            slidesPerView="auto"
            onSlideChange={(swiper) => console.log()}
            onSwiper={(swiper) => console.log()}
        >
            {
                babiesLooks?.map((babies,index) =>{
                    return babies?.imageURLs.map((item,index2) =>{
                        return <SwiperSlide key={index2} className={classes.SwiperItem}>
                            <div className={classes.Image} onClick={()=>onShow(index+1,babies)}>
                                <img className={classes.NormalImage} src={`${IMAGE_GEEKO_LTD}/comment/medium/${item}`} alt="ProductBabies"/>

                                {
                                    index2===0 && babies?.videoIds?.length > 0 && <BabiesElement selectedProduct={selectedProduct} />
                                }
                            </div>
                        </SwiperSlide>
                    })
                })
            }
        </Swiper>
    )
}

const ProductBabiesLooksItem = withFirst(props =>{
    useStyles(classes);
    const { innerRef, babiesLooks, selectedProduct, hasRollingMessage, babiesLookShow, setBabiesLookShow } = props;
    const [babiesPosition, setBabiesPosition] = useState(0);
    const fetchIds = babiesLooks?.map(item =>item?.productCommentId).join(",");

    // const babiesArr = babiesLooks?.reduce((preValue,currentValue) =>[...preValue,...currentValue?.imageURLs],[]);

    const babiesModalShow = (position, babies) =>{
        setBabiesLookShow(true);
        setBabiesPosition(position);

        if(window.GeekoSensors){
			window.GeekoSensors.Track("ProductListClick", {
				column:"Show"
			})
		}

        if(babies?.videoIds?.length > 0){
            if(window.GeekoSensors) {
                window.GeekoSensors.Track("ShowVideoClick", {
                    product_id:selectedProduct?.id
                });
            }
        }
    }

    const babiesModalHide = () => {
        setBabiesLookShow(false);
        setBabiesPosition(0);
    }

    return <div ref={innerRef}>
         <div className={classes.ProductBabiesLooks}>
            <div className={classes.Hd}>
                <div>
                    <span><FormattedMessage id="influencer_outfit" defaultMessage="Influencer Outfit" /></span>
                </div>
                <div onClick={() =>babiesModalShow(0, null)}>
                    <Iconfont>&#xe694;</Iconfont>
                </div>
            </div>

            <div className={classes.Bd}>
                <BabiesSwiper babiesLooks={babiesLooks} onShow={(position,babies)=>babiesModalShow(position, babies)} selectedProduct={selectedProduct} />
            </div>

            <BabiesModal babiesLookShow={babiesLookShow} babiesPosition={babiesPosition} ids={fetchIds} onClose={babiesModalHide} hasRollingMessage={hasRollingMessage} />
        </div>
    </div>
})

const ProductBabiesLooks = props =>{
    useStyles(classes);

    const initLoad = () =>{
        if(window.GeekoSensors){
            window.GeekoSensors.Track("ProductListExposure", {
                column:"Show",
            })
        }
    }    

    return <ProductBabiesLooksItem initLoad={() =>initLoad()} {...props} />
}

export default ProductBabiesLooks;